import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Send Questions and Feedback", -1)
const _hoisted_2 = { class: "field" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Your Name", -1)
const _hoisted_4 = { class: "field" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Your Email", -1)
const _hoisted_6 = { class: "field" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "message" }, "Message", -1)
const _hoisted_8 = { class: "form-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("form", {
      class: "form",
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_InputText, {
          id: "name",
          type: "text",
          placeholder: "Firstname Lastname",
          required: "",
          modelValue: _ctx.message.contact,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.message.contact) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_InputText, {
          id: "email",
          type: "email",
          placeholder: "name@email.com",
          required: "",
          modelValue: _ctx.message.source,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.message.source) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(_component_Textarea, {
          required: "",
          id: "message",
          modelValue: _ctx.message.content,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.message.content) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_Button, {
          label: "Submit",
          type: "submit"
        })
      ])
    ], 32)
  ], 64))
}